export default function useMeta({ metaTitle, metaDescription, metaImage }) {
  return {
    title: metaTitle,
    description: metaDescription,
    image: metaImage?.file?.url,
  }
}
